import airconChemicalOverhaul from "./assets/aircon-chemical-overhaul.png";
import airconChemicalWash from "./assets/aircon-chemical-wash.png";
import airconCompressorWash from "./assets/aircon-compressor-wash.png";
import airconGasTopUp from "./assets/aircon-gas-top-up.png";
import airconInstallation from "./assets/aircon-installation.png";
import airconRepair from "./assets/aircon-repair.png";
import aircon from "./assets/aircon.png";
import babysitting from "./assets/babysitting.png";
import business from "./assets/business.png";
import carService from "./assets/car-service.png";
import carpetCleaning from "./assets/carpet-cleaning.png";
import commercialPestControl from "./assets/commercial-pest-control.png";
import commercial from "./assets/commercial.png";
import condominiumCleaning from "./assets/condominium-cleaning.png";
import confinementNanny from "./assets/confinement-nanny.png";
import curtainCleaning from "./assets/curtain-cleaning.png";
import deepCleaning from "./assets/deep-cleaning.png";
import eldercareMedicalEscort from "./assets/eldercare-medical-escort.png";
import eldercare from "./assets/eldercare.png";
import electrician from "./assets/electrician.png";
import equipment from "./assets/equipment.png";
import eyelash from "./assets/eyelash.png";
import floorPolisher from "./assets/floor-polisher.png";
import fnbPestControl from "./assets/fnb-pest-control.png";
import formaldehydeRemoval from "./assets/formaldehyde-removal.png";
import handyman from "./assets/handyman.png";
import homeBeauty from "./assets/home-beauty.png";
import homeCleaning from "./assets/home-cleaning.png";
import homeFacial from "./assets/home-facial.png";
import homeMassage from "./assets/home-massage.png";
import individual from "./assets/individual.png";
import industrialCleaning from "./assets/industrial-cleaning.png";
import maidAgency from "./assets/maid-agency.png";
import mattressCleaning from "./assets/mattress-cleaning.png";
import moveInOutCleaning from "./assets/move-in-out-cleaning.png";
import officeCleaning from "./assets/office-cleaning.png";
import pestControl from "./assets/pest-control.png";
import petGrooming from "./assets/pet-grooming.png";
import petSitting from "./assets/pet-sitting.png";
import plumbing from "./assets/plumbing.png";
import postRenoCleaning from "./assets/post-reno-cleaning.png";
import pramCarSeatCleaning from "./assets/pram-car-seat-cleaning.png";
import residentialPestControl from "./assets/residential-pest-control.png";
import security from "./assets/security.png";
import sofaCleaning from "./assets/sofa-cleaning.png";
import specializedCleaning from "./assets/specialized-cleaning.png";
import springCleaning from "./assets/spring-cleaning.png";
import viewMore from "./assets/view-more.png";

export const serviceIconRegistry = {
  // Cleaning & Maintenance
  "home-cleaning": homeCleaning,
  "deep-cleaning": deepCleaning,
  "mattress-cleaning": mattressCleaning,
  "sofa-cleaning": sofaCleaning,
  "carpet-cleaning": carpetCleaning,
  "curtain-cleaning": curtainCleaning,
  "pram-car-seat-cleaning": pramCarSeatCleaning,
  "floor-polisher": floorPolisher,
  "move-in-out-cleaning": moveInOutCleaning,
  "post-reno-cleaning": postRenoCleaning,
  "spring-cleaning": springCleaning,
  "formaldehyde-removal": formaldehydeRemoval,

  // Business
  business: business,
  individual: individual,

  // Aircon
  aircon: aircon,
  "aircon-chemical-wash": airconChemicalWash,
  "aircon-chemical-overhaul": airconChemicalOverhaul,
  "aircon-compressor-wash": airconCompressorWash,
  "aircon-gas-top-up": airconGasTopUp,
  "aircon-repair": airconRepair,
  "aircon-installation": airconInstallation,

  // Beauty & Personal Care
  "home-beauty": homeBeauty,
  eyelash: eyelash,
  "home-massage": homeMassage,
  "home-facial": homeFacial,

  // Child & Elder Care
  eldercare: eldercare,
  babysitting: babysitting,
  "maid-agency": maidAgency,
  "eldercare-medical-escort": eldercareMedicalEscort,
  "confinement-nanny": confinementNanny,

  // Pet Care
  "pet-sitting": petSitting,
  "pet-grooming": petGrooming,

  // Home Repairs
  handyman: handyman,
  plumbing: plumbing,
  electrician: electrician,

  // Vehicle
  "car-service": carService,

  // Pest Control
  "pest-control": pestControl,
  "residential-pest-control": residentialPestControl,
  "commercial-pest-control": commercialPestControl,
  "fnb-pest-control": fnbPestControl,

  // Others
  "specialized-cleaning": specializedCleaning,
  "office-cleaning": officeCleaning,
  security: security,
  commercial: commercial,
  "condominium-cleaning": condominiumCleaning,
  "industrial-cleaning": industrialCleaning,
  equipment: equipment,
  "view-more": viewMore,
} as const;

export type ServiceIconName = keyof typeof serviceIconRegistry;
